<template>
  <v-card class="text-center">
    <div class="pt-6">
      <v-icon
        :color="color"
        x-large
      >
        {{ icon }}
      </v-icon>
    </div>

    <v-card-text
      class="display-1 font-weight-light font-italic mb-3"
      v-text="msg"
    />
  </v-card>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'CardAlert',

    /* Paramètres */
    props: {
      msg: {
        type: String,
        default: 'Une erreur est survenue lors de la génération de ce graphique.',
      },
      icon: {
        type: String,
        default: 'mdi-alert-rhombus-outline',
      },
      color: {
        type: String,
        default: 'error',
      },
    },
  }
</script>
